import { Card, Typography } from "antd";
import { Flex } from "common/components/flex/flex";

const { Title, Text } = Typography;

const titleJustifyMap = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
};

export const Section = ({
  title,
  subtitle,
  extra,
  children,
  headerClassName,
  contentClassName,
  titleAlign = "left",
  contentMinHeight = "120px",
}) => (
  <Card bodyStyle={{ padding: 16 }} style={{ lineHeight: 1 }}>
    <Flex direction="column" gap={12} style={{ height: "100%" }}>
      <Flex
        justify="space-between"
        align="center"
        style={{ minHeight: 32 }}
        className={headerClassName}
      >
        <Flex
          gap={12}
          align="baseline"
          justify={titleJustifyMap[titleAlign] || titleJustifyMap.left}
          style={{ flex: 1 }}
        >
          <Title level={5} style={{ margin: 0 }}>
            {title}
          </Title>
          {subtitle && <Text className="text-secondary">{subtitle}</Text>}
        </Flex>

        {extra}
      </Flex>

      <div
        className={contentClassName}
        style={{ flex: `1 0 ${contentMinHeight}` }}
      >
        {children}
      </div>
    </Flex>
  </Card>
);
